import {SmartComponent} from "smart-component-js";
import IconManager from "../utils/IconManager";

class DefaultCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.el = element;
        this.init();
    }

    addShowPasswordButton() {
        const passwordInputs = document.querySelectorAll('input[type="password"]');
        passwordInputs.forEach((input) => {
            const wrapper = input.parentElement;
            wrapper.insertAdjacentHTML('beforeend', '<button type="button" class="visibility-icon"></button>');
            this.addPasswordListener(wrapper, input);
        });
    }


    addPasswordListener(wrapper, input) {
        wrapper.querySelector('.visibility-icon').addEventListener('click', () => {
            const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
            input.setAttribute('type', type);
            wrapper.classList.toggle('password-visible');
        });
    }

    init() {
        this.loadChildComponents(this);
        window.iconManager = new IconManager();

        document.addEventListener("yxp-form-loaded", () => {
            this.loadChildComponents(this);
            this.addShowPasswordButton();
        });
    }
}

export default DefaultCtrl;
